// The short notice shown at signup (DPDP gap G1, Act s.5(1), Rule 3; founder
// 2026-10-29). Rule 3 asks for a notice that stands on its own, in plain words,
// and itemises: the data, each purpose, how to withdraw consent, how to use
// the rights, and how to complain to the Data Protection Board. It is a
// SUMMARY of src/legal/privacy.ts and must never say more than the policy does:
// when the policy changes, re-read every line here.
//
// Shared byte-identical with mobile/src/core/signupNotice.ts (check:shared-sync),
// so both clients show the same words and share one set of translations. The
// strings render through t(value), so they live here, in src/lib, where
// check:i18n-coverage rule (c) requires every one of them in every language.
// Compliance copy: machine-translated, blind back-translated, and listed in
// machine-translated-compliance.json.
export const SIGNUP_NOTICE_TITLE = 'What we collect and why';

export const SIGNUP_NOTICE_ITEMS: readonly { heading: string; text: string }[] = [
  {
    heading: 'What we collect',
    text: 'Your name and email address, the holdings, figures and notes you enter or import, your settings, and the sign-in, device and security records that keep your account safe.',
  },
  {
    heading: 'Why we use it',
    text: 'To run your account and show you your own portfolio, to keep your account secure, and to meet our legal duties. We do not sell your personal data.',
  },
  {
    heading: 'Optional features ask first',
    text: 'Linking a broker, AI answers, step credit and household sharing each ask for your permission separately, and nothing else in Sansara depends on them.',
  },
  {
    heading: 'Withdrawing consent',
    text: 'You can turn off any permission at any time in Data & Privacy, and delete your account at any time in Settings → Your data.',
  },
  {
    heading: 'Your rights',
    text: 'You can see a summary of your data, correct it, have it erased, name someone to act for you, and complain to our Grievance Officer at grievance@sansarafin.com.',
  },
  {
    heading: 'Complaints to the Board',
    text: 'If you are not satisfied with how we handle your complaint, you can complain to the Data Protection Board of India.',
  },
];
